const getSelectedHotelId = state => state?.dashboard?.active_hotel_id;

export default getSelectedHotelId;
